import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CnafContacterMaCafService} from '../../../services/contactermacaf.service';
import {HttpClient} from '@angular/common/http';
import { ContactermacafMotifsdecontactComponent } from '../../contactermacaf-motifsdecontact.component';
import { TagXitiService } from 'src/app/services/tagxiti.service';
import { CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { BsModalService } from 'ngx-bootstrap/modal';
import {context} from '../../../../contexts/context';

@Component({
  selector: 'app-contactermacaf-motifsdecontact-actualites',
  templateUrl: 'motifsdecontact-actualites.component.html',
  styleUrls: ['../../contactermacaf-motifsdecontact.component.css']
})
export class MotifsdecontactActualitesComponent extends ContactermacafMotifsdecontactComponent implements OnInit {

   constructor(private _router: Router,
              private _cnafContacterMaCafService: CnafContacterMaCafService,
              private _http : HttpClient,
              private  _tagXitiService: TagXitiService,
              private _cnafAtTagService: CnafAtTagService,
              private readonly _modalService: BsModalService) {
                super(_router,_cnafContacterMaCafService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onLienBoutonSaisonnierActuel() {
    if(this.boutonSaisonnierActuel?.lien){
      const tagObj = this._tagXitiService.getAtTagObject(
        'btn_consulter_article ',
        context.type,
        'contactermacaf',
        'svi_visuel_choix_motif',
        this.boutonSaisonnierActuel?.tagChapitre3
      );
      tagObj.customPropsPersistent = {
        'svi_profil': this._tagXitiService.getProfilutilisateur()
      };
      this._cnafAtTagService.pageSend(tagObj);
    }
    setTimeout(() => {
      window.location.href = this.boutonSaisonnierActuel!.lien;
    }, 300);
  }
}
